import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import './Services.css';
import './Carousel.css';

// Stable carousel image list used by Services component
const CAROUSEL_IMAGES_CONST = [
  { src: "/images/gallery/collection_1.jpg", alt: "Collection 1" },
  { src: "/images/gallery/collection_2.png", alt: "Collection 2" },
  { src: "/images/gallery/collection_3.jpg", alt: "Collection 3" },
  { src: "/images/gallery/collection_4.jpg", alt: "Collection 4" },
  { src: "/images/gallery/collection_5.png", alt: "Collection 5" },
  { src: "/images/gallery/collection_6.jpg", alt: "Collection 6" },
];

// Professional SVG Icons
const CameraIcon = () => (
  <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 4H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="13" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TraditionalIcon = () => (
  <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const AlbumIcon = () => (
  <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 9H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const FrameIcon = () => (
  <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="7" y="7" width="10" height="10" rx="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 3V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 3V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 21V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 21V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const HeartIcon = () => (
  <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99871 7.05 2.99871C5.59096 2.99871 4.19169 3.57831 3.16 4.61C2.1283 5.64169 1.54871 7.04097 1.54871 8.5C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7564 11.2728 22.0329 10.6054C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.0621 22.0329 6.39464C21.7564 5.72718 21.351 5.12075 20.84 4.61Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CakeIcon = () => (
  <svg className="service-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 21V8H4V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 12H8.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 12H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 12H16.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 16H8.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 16H16.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const servicesData = [
  {
    icon: CameraIcon,
    title: 'Candid Photography & Video',
    description: 'Capturing moments naturally as they unfold, creating authentic and emotional memories.',
  },
  {
    icon: TraditionalIcon,
    title: 'Traditional Photography & Video',
    description: 'Classic ceremonies and traditional events captured with timeless elegance.',
  },
  {
    icon: AlbumIcon,
    title: 'Custom Albums',
    description: "Beautifully designed photo albums that tell your story in a unique way.",
  },
  {
    icon: FrameIcon,
    title: 'Premium Frames',
    description: 'High-quality framed prints to display your precious memories.',
  },
  {
    icon: HeartIcon,
    title: 'Post Wedding Shoot',
    description: 'Creative couple shoots in beautiful locations for romantic memories.',
  },
  {
    icon: CakeIcon,
    title: 'Birthday Shoot',
    description: 'Fun and memorable birthday moments captured with joy and celebration.',
  },
];

const Services = () => {
  // --- Image carousel state & logic moved here from Carousel.js ---
  // use the pre-defined constant array
  const CAROUSEL_IMAGES = CAROUSEL_IMAGES_CONST;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const totalImages = CAROUSEL_IMAGES.length;
  const slideWidth = 100 / totalImages;
  const loopImages = useMemo(() => [...CAROUSEL_IMAGES, ...CAROUSEL_IMAGES], [CAROUSEL_IMAGES]);
  const continuous = false;
  const PER_IMAGE_SECONDS = 5; // image visible time in seconds (changed from 40 to 3)
  const resumeTimerRef = useRef(null);

  const nextImage = useCallback(() => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % totalImages);
  }, [totalImages]);

  const prevImage = useCallback(() => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + totalImages) % totalImages);
  }, [totalImages]);

  useEffect(() => {
    if (isPaused) return undefined;
    const interval = setInterval(nextImage, PER_IMAGE_SECONDS * 1000);
    return () => clearInterval(interval);
  }, [nextImage, isPaused]);

  const handleUserInteraction = (action) => {
    action();
    setIsPaused(true);
    if (resumeTimerRef.current) clearTimeout(resumeTimerRef.current);
    resumeTimerRef.current = setTimeout(() => setIsPaused(false), 6000);
  };

  useEffect(() => {
    return () => {
      if (resumeTimerRef.current) {
        clearTimeout(resumeTimerRef.current);
        resumeTimerRef.current = null;
      }
    };
  }, []);

  const carouselStyle = useMemo(() => ({
    width: `${totalImages * 100}%`,
    transform: `translateX(-${currentIndex * slideWidth}%)`,
    transition: 'transform 0.5s ease-in-out',
    display: 'flex',
  }), [currentIndex, slideWidth, totalImages]);
  const firstRow = servicesData.slice(0, 3);
  const secondRow = servicesData.slice(3, 6);

  const renderCards = (row) => (
    <div className="services-row">
      {row.map(({ icon: Icon, title, description }) => (
        <div className="service-card" key={title}>
          <div className="service-icon">
            <Icon />
          </div>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      ))}
    </div>
  );

  return (
    <section id="services" className="services-section">
      <div className="container">
        <h2>Our Services</h2>

        {/* Inserted image carousel (copied from Carousel.js) */}
        <div className="carousel-wrapper">
          <main className="carousel-main">
            <section id="carousel-inline" className="carousel-section">
              <div
                className="carousel-container"
                role="region"
                aria-label="Featured photography"
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                onFocus={() => setIsPaused(true)}
                onBlur={() => setIsPaused(false)}
              >
                {continuous ? (
                  <div
                    className="carousel-track continuous"
                    aria-live="off"
                    style={{ '--duration': `${totalImages * PER_IMAGE_SECONDS}s`, '--items': loopImages.length }}
                  >
                    {loopImages.map((img, index) => (
                      <div key={index} className="carousel-item">
                        <img
                          src={img.src}
                          alt={img.alt}
                          className="carousel-image"
                          onError={(e) => { e.target.src = 'https://placehold.co/1200x600/6b7280/ffffff?text=Image+Load+Error'; }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="carousel-track" style={carouselStyle} aria-live="polite">
                    {CAROUSEL_IMAGES.map((img, index) => (
                      <div key={index} className="carousel-item">
                        <img
                          src={img.src}
                          alt={img.alt}
                          className="carousel-image"
                          onError={(e) => { e.target.src = 'https://placehold.co/1200x600/6b7280/ffffff?text=Image+Load+Error'; }}
                        />
                      </div>
                    ))}
                  </div>
                )}

                <button type="button" onClick={() => handleUserInteraction(prevImage)} className="carousel-nav prev-button" aria-label="Previous image">
                  <svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                </button>
                <button type="button" onClick={() => handleUserInteraction(nextImage)} className="carousel-nav next-button" aria-label="Next image">
                  <svg xmlns="http://www.w3.org/2000/svg" className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                </button>

                <div className="carousel-indicators">
                  {CAROUSEL_IMAGES.map((_, index) => (
                    <button
                      type="button"
                      key={index}
                      onClick={() => handleUserInteraction(() => setCurrentIndex(index))}
                      className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </section>
          </main>
        </div>

        <div className="services-grid">
          {renderCards(firstRow)}
          {renderCards(secondRow)}
        </div>
      </div>
    </section>
  );
};

export default Services;
